import dayjs from 'dayjs'
import { JsonProperty, Serializable } from 'ts-jackson'
import { Fromable } from '../model'

export interface DocusignResponse {
  id: number
  userId: number
  envelopeId: string
  templateId: string
  status: string
  signUrl: string
  completedAt: string | null
  statusUpdatedAt: string
  createdAt: string
  updatedAt: string
}

@Serializable()
export class DocumentListResponse extends Fromable {
  @JsonProperty('id')
  id!: number

  @JsonProperty('userId')
  userId!: number

  @JsonProperty('envelopeId')
  envelopeId!: string

  @JsonProperty('templateName')
  templateName!: string[]

  @JsonProperty('templateId')
  templateId!: string

  @JsonProperty('status')
  status!: string

  @JsonProperty('completedAt')
  completedAt?: string | null

  @JsonProperty('statusUpdatedAt')
  statusUpdatedAt!: string

  @JsonProperty('createdAt')
  createdAt!: string

  @JsonProperty('updatedAt')
  updatedAt!: string

  public DataForTable() {
    return {
      id: this?.id,
      createdAt: this.createdAt ? dayjs(this.createdAt).format('DD MMM YYYY HH:mm:ss') : '-',
      type: this.templateName?.join(', ') || '-',
      fileName: this.envelopeId || '-',
      status: this.status || '-',
      packageName: this.templateId || '-',
    }
  }
}
